import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from "reactstrap";

import emailjs from "@emailjs/browser";

import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import BuildIcon from "@mui/icons-material/Build";
import MessageIcon from "@mui/icons-material/Message";
import SendIcon from "@mui/icons-material/Send";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';

import { Helmet } from "react-helmet-async";
import { createEnquiry } from "../API/apiconst";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

interface FormData {
  name: string;
  email: string;
  phoneNumber: string,
  purpose: string;
  message: string;
}

interface HomeContactProps {
  purpose: string;
  closeModal: () => void;
}

const Homecontact: React.FC<HomeContactProps> = ({
  purpose,closeModal
}) => {
  const [modal, setModal] = useState<boolean>(false);

const headingMap: Record<string, string> = {
  "Creo Get Instant Quote": "Buy Creo ToolKit Licenses",
  "Creo Book Consultation": "Book a Creo ToolKit Consultation",
  "Creo Training": "Creo ToolKit Training",
};

  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    phoneNumber: "",
    purpose: purpose,
    message: "",
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      purpose: purpose,
    }));
  }, [purpose]);

  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
    const [onclose, setOnclose] = useState<((open: boolean) => void) | null>(null);

const [modalTitle, setModalTitle] = useState("");
  const toggle = () => setModal(!modal);
  const [selectedPurpose, setSelectedPurpose] = useState("");

const openModal = (type: string) => {
  setSelectedPurpose(type);
  setModalTitle(type);
  setModal(true);
};
  



  // INPUT CHANGE
const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};



  const handleSubmit = async (e: any) => {

    e.preventDefault();
    onclose?.(false);

    try {
      await createEnquiry(formData);
      toast.success("Form submitted successfully!");

      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        purpose: purpose,
        message: "",
      });

    }
    catch (err: any) {
      toast.error("Failed to submit");
    }
  }

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          Contact Creo Toolkit Experts | Creo Automation &
          Customization
        </title>

        <meta
          name="description"
          content="Contact us for Creo Toolkit training, CAD automation, Creo customization, plugin development, enterprise integration, and engineering workflow solutions."
        />

        <meta
          name="keywords"
          content="
            Contact Creo Toolkit,
            Creo Automation,
            Creo Customization,
            Creo Training,
            CAD Automation,
            Creo API,
            Creo Plugin Development,
            PTC Creo,
            Creo Consulting,
            Engineering Automation
          "
        />

        <meta
          name="author"
          content="Creo Toolkit Solutions"
        />

        <meta
          name="robots"
          content="index, follow"
        />

        {/* OPEN GRAPH */}
        <meta
          property="og:title"
          content="Contact Creo Toolkit Experts"
        />

        <meta
          property="og:description"
          content="Get in touch for Creo Toolkit training, CAD automation, and engineering consulting services."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://creotoolkit.com/contact"
        />

        {/* TWITTER */}
        <meta
          name="twitter:image"
          content="https://creo-toolkit.com/images/contact-banner.jpg"
        />

        <meta
          name="twitter:title"
          content="Contact Creo Toolkit Experts"
        />

        <meta
          name="twitter:description"
          content="Professional Creo Toolkit consulting and training services."
        />

        {/* CANONICAL */}
        <link
          rel="canonical"
          href="https://creo-toolkit.com/contact"
        />
      </Helmet>

      <main
        className="main-wrapper"
        style={{
          minHeight: "40vh",
          background:
            "linear-gradient(135deg,#020617,#0f172a,#111827)",
          padding: "80px 20px",
          display: "flex",
          alignItems: "center",
        }}
      >
        
        <section className="contact-form-card" style={{ width: "800px" }}>
         {/* Flex container to align Heading and Button side-by-side */}
<div className="d-flex justify-content-between align-items-center" style={{ marginBottom: "10px" }}>
  <h2
    style={{
      color: "#fff",
      fontSize: "38px",
      fontWeight: 700,
      margin: 0, // Removed bottom margin so it aligns perfectly with the button
    }}
  >
     {headingMap[purpose] || `Creo ToolKit ${purpose}`}
  </h2>
  
  <Button type="button" className="btn btn-secondary" onClick={closeModal}>
    <CloseIcon/>
  </Button>
</div>

{/* Description stays underneath */}
<p className="cta-description">
  Fill out the form and our team will get back to you shortly.
</p> 
         

          {success && (
            <Alert
              color="success"
              style={{
                borderRadius: "12px",
              }}
            >
              Email sent successfully!
            </Alert>
          )}

          {error && (
            <Alert
              color="danger"
              style={{
                borderRadius: "12px",
              }}
            >
              Failed to send email.
            </Alert>
          )}

        <Form onSubmit={handleSubmit} >
  <Row>
    {/* NAME */}
    <Col md={4}>
      <FormGroup className="mb-4">
        <div className="input-wrapper">
          <PersonIcon className="input-icon" />
          <Input
            id="name"
            type="text"
            name="name"
            placeholder="Enter your full name"
            value={formData.name}
            onChange={handleChange}
            required
            className="custom-input"
          />
        </div>
      </FormGroup>
    </Col>

    {/* EMAIL */}
    <Col md={4}>
      <FormGroup className="mb-4">
        <div className="input-wrapper">
          <EmailIcon className="input-icon" />
          <Input
            id="email"
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
            className="custom-input"
          />
        </div>
      </FormGroup>
    </Col>

    {/* PHONE */}
    <Col md={4}>
      <FormGroup className="mb-4">
        <div className="input-wrapper">
          <LocalPhoneIcon className="input-icon" />
          <Input
            id="number"
            type="text"
            name="phoneNumber"
            placeholder="Enter your Phone No"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
            className="custom-input"
          />
        </div>
      </FormGroup>
    </Col>

    {/* Hidden Purpose for Database */}
    <Input
      type="hidden"
      name="purpose"
      value="Creo Training"
    />

    {/* MESSAGE */}
    <Col md={12}>
      <FormGroup className="mb-4">
        <div className="input-wrapper">
          <MessageIcon className="input-icon" />
          <Input
            id="message"
            type="textarea"
            name="message"
            rows={5}
            placeholder="Tell us about your requirement..."
            value={formData.message}
            onChange={handleChange}
            required
            className="custom-input custom-textarea"
          />
        </div>
      </FormGroup>
    </Col>

    {/* BUTTON */}
    <Col md={12}>
      <Button
        type="submit"
        disabled={loading}
        className="primary-btn"
        style={{
          width: "100%",
          height: "58px",
          borderRadius: "16px",
        }}
      >
        {loading ? (
          "Sending..."
        ) : (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <SendIcon />
            Send Message
          </span>
        )}
      </Button>
    </Col>
  </Row>
</Form>
        </section>
      </main>
    </>
  );
};

export default Homecontact;